import { ApiHttpService } from '../../services'

import router from '../../router'
export const ContactSalesReportModule = {
    namespaced: true,
    state: {
        formData: null,
        initFormData: {
            id : null,
            name : null,
            mobile : null,
            employee_code : null,
            designation : null,
            location : [],
            ytd : [],
            mtd : [],
            brand_sales : [],
            category_sales : [],
            location_sales : [],
        },
        request: null,
        loading : false,
    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}
        },
        cancelRequest : (state) => {

            if(state.request != null){
                state.request.cancel()
            }
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },

        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setFormData : (state, payload)=>{
            state.formData = payload
        },
    },
    actions : {
        resetData({dispatch}, endpoint){
            return new Promise((resolve, reject) => {
                dispatch('asyncGetData', endpoint).then((res) => {
                    resolve(res)
                }).catch(error => {

                    console.log("reset error")
                    console.log(error)
                    reject(error)
                })
        });
        },
        async asyncGetData({ commit, state},obj) {
            return await new Promise((resolve, reject) => {
                    commit('setLoading', true)
                    const params = {...obj,view : router.app._route.name }
                    const configParams = {
                        req : "ContactSalesReportModule/req",
                        loadingTrue : "ContactSalesReportModule/loadingTrue",
                        addRequest : "ContactSalesReportModule/addRequest",
                        cancelRequest : "ContactSalesReportModule/cancelRequest",
                        clearOldRequest : "ContactSalesReportModule/clearOldRequest"
                    }
                    const formData = {
                        ...state.initFormData,
                        ...params
                    }
                    commit('setFormData', formData)
                    ApiHttpService.get(`sales-report`, params, configParams).then((response) => {
                        const responseData = {
                            ...formData,
                            ...response.data
                        }
                        commit('setFormData',responseData)
                        resolve(responseData)
                        commit('setLoading', false)
                    }).catch(error => {
                        commit('setLoading', false)
                        reject(error)
                    })

            })
        },
    },
    getters: {
        loading : state => state.loading,
        req: state => state.request,
        formData: state => state.formData,
        initFormData: state => state.initFormData,
    }
}
